// @flow
import React, { Fragment } from "react";
import { withGlobalContext } from "../../../common/GlobalContext";

import GridButtons from "./GridButtons";
import GrayGridList from "./GrayGridList";
import GrayGridButtonList from "./GrayGridButtonList";

import type { $Site } from "flow/types";

type $Props = {
  site: $Site,
  homepageFeaturedTownsHeroImage: string,
};

const FeaturedTowns = ({ site, homepageFeaturedTownsHeroImage }: $Props) => {
  const { pods } = site.uiConfig;

  return (
    <Fragment>
      {pods.map((pod) => {
        if (
          pod.value === "gridButtonsFeaturedTowns" ||
          pod.value === "mapCardsFeaturedTowns"
        ) {
          return (
            <GridButtons
              key={pod.value}
              backgroundImage={homepageFeaturedTownsHeroImage}
            />
          );
        } else if (pod.value === "grayGridListTowns") {
          return <GrayGridList key={pod.value} />;
        } else if (pod.value === "grayBackgroundGridFeaturedTowns") {
          return <GrayGridButtonList key={pod.value} />;
        } else {
          return null;
        }
      })}
    </Fragment>
  );
};

export default withGlobalContext(FeaturedTowns);
